import { render, staticRenderFns } from "./CreateReportGeneration.vue?vue&type=template&id=2ac6c1ba&scoped=true"
import script from "./CreateReportGeneration.vue?vue&type=script&lang=js"
export * from "./CreateReportGeneration.vue?vue&type=script&lang=js"
import style0 from "./CreateReportGeneration.vue?vue&type=style&index=0&id=2ac6c1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac6c1ba",
  null
  
)

export default component.exports